var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMileageDeviations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.594 14.8894L16.3415 1.63692C15.951 1.24639 15.3178 1.24639 14.9273 1.63692L1.67486 14.8894C1.28434 15.2799 1.28434 15.9131 1.67486 16.3036L14.9273 29.556C15.3178 29.9466 15.951 29.9466 16.3415 29.556L29.594 16.3036C29.9845 15.9131 29.9845 15.2799 29.594 14.8894Z",
    stroke: "#212B33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7061 19.4362C18.7061 20.2844 19.3937 20.972 20.2419 20.972C21.0902 20.972 21.7778 20.2844 21.7778 19.4362C21.7778 18.5879 21.0902 17.9003 20.2419 17.9003C19.3937 17.9003 18.7061 18.5879 18.7061 19.4362ZM18.7061 19.4362H12.0505C11.3716 19.4362 10.7205 19.1665 10.2405 18.6864C9.76042 18.2063 9.49072 17.5552 9.49072 16.8763C9.49072 16.1974 9.76042 15.5463 10.2405 15.0663C10.7205 14.5862 11.3716 14.3165 12.0505 14.3165H18.1941C18.7372 14.3165 19.2581 14.1008 19.6421 13.7167C20.0262 13.3327 20.2419 12.8118 20.2419 12.2687C20.2419 11.7256 20.0262 11.2047 19.6421 10.8206C19.2581 10.4366 18.7372 10.2208 18.1941 10.2208H12.0505",
    stroke: "#1D1F2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageDeviations);
export default __webpack_public_path__ + "static/media/mileage-deviations.df8d47451cad928166a582a42fe893bf.svg";
export { ForwardRef as ReactComponent };